var render = function render(){
  var _vm$rules$_vm$COMPANY, _vm$rules$_vm$COMPANY2, _vm$rules$_vm$COMPANY3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('v-form', {
    staticClass: "pa-16",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    },
    model: {
      value: _vm.isValid,
      callback: function ($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "아이디",
      "rules": _vm.rules.username,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.username,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "username", $$v);
      },
      expression: "inputs.username"
    }
  }), _c('v-password-field', {
    attrs: {
      "label": "비밀번호",
      "rules": _vm.rules.password,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.password,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "password", $$v);
      },
      expression: "inputs.password"
    }
  }), _c('v-password-confirm-field', {
    attrs: {
      "label": "비밀번호확인",
      "password": _vm.inputs.password,
      "outlined": "",
      "dense": ""
    }
  }), _c('user-contact-certification', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'primary',
        width: 100,
        height: 50,
        className: 'mt-n8'
      }
    },
    model: {
      value: _vm.inputs.phone,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "phone", $$v);
      },
      expression: "inputs.phone"
    }
  }), _c('v-divider', {
    staticClass: "mb-26"
  }), _c('v-text-field', {
    attrs: {
      "label": "기업명*",
      "rules": (_vm$rules$_vm$COMPANY = _vm.rules[_vm.COMPANY.value]) === null || _vm$rules$_vm$COMPANY === void 0 ? void 0 : _vm$rules$_vm$COMPANY.name,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.name,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "name", $$v);
      },
      expression: "inputs.name"
    }
  }), _c('v-file-input', {
    attrs: {
      "label": "사업자등록증*",
      "outlined": "",
      "dense": "",
      "prepend-icon": null,
      "prepend-inner-icon": "mdi-file-upload-outline",
      "rules": (_vm$rules$_vm$COMPANY2 = _vm.rules[_vm.COMPANY.value]) === null || _vm$rules$_vm$COMPANY2 === void 0 ? void 0 : _vm$rules$_vm$COMPANY2.businessRegistration
    },
    model: {
      value: _vm.inputs.businessRegistration,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "businessRegistration", $$v);
      },
      expression: "inputs.businessRegistration"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "대표자 성명*",
      "rules": (_vm$rules$_vm$COMPANY3 = _vm.rules[_vm.COMPANY.value]) === null || _vm$rules$_vm$COMPANY3 === void 0 ? void 0 : _vm$rules$_vm$COMPANY3.ceoName,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.ceoName,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "ceoName", $$v);
      },
      expression: "inputs.ceoName"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "이메일*",
      "rules": _vm.rules.email,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.email,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "email", $$v);
      },
      expression: "inputs.email"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "홈페이지 주소",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.website,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "website", $$v);
      },
      expression: "inputs.website"
    }
  }), _c('v-address-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'primary',
        width: 100,
        height: 50,
        className: 'mt-n8'
      }
    },
    model: {
      value: _vm.inputs,
      callback: function ($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }), _c('terms-of-agreements-short', {
    on: {
      "isValid": function (isValid) {
        return _vm.isTermsValid = isValid;
      }
    },
    model: {
      value: _vm.inputs._terms,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "_terms", $$v);
      },
      expression: "inputs._terms"
    }
  })], 1), _c('v-btn', {
    staticClass: "primary white--text",
    attrs: {
      "disabled": !_vm.isValid,
      "x-large": "",
      "block": "",
      "tile": ""
    },
    on: {
      "click": _vm.join
    }
  }, [_vm._v("회원가입")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }